import React from 'react';
import ReactDOM from 'react-dom/client';
import DigidemApp from './Digidemapp';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <DigidemApp />
  </React.StrictMode>
);